export const FOLDER_SIDEBAR_WIDTH = 256;